import { SignatureCard } from '@common/SignatureCard';
import { FormFieldMethods, FormTextarea, Grid, Heading, HeadingType, Label } from '@gcl/react-core';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';
import * as React from 'react';
import './ProjectTwcGeRequestDetailSignatureCard.scss';

interface IProjectTwcGeRequestDetailSignatureCardProps {
  formFieldMethods: FormFieldMethods;
  title: string;
  description: string;
  signatureLabel: string;
  approver?: IProjectUserProfile;
  approvedDate?: string;
  commentFormKey: string;
  readonly: boolean;
}
export const ProjectTwcGeRequestDetailSignatureCard: React.FunctionComponent<
  IProjectTwcGeRequestDetailSignatureCardProps
> = ({ formFieldMethods, title, description, signatureLabel, approver, approvedDate, commentFormKey, readonly }) => {
  return (
    <div className="gcl-gems-twc-ge-request-detail-signature-card-container">
      <SignatureCard
        className="gcl-gems-twc-ge-request-detail-signature-card"
        title={
          <div className="gcl-gems-twc-ge-request-detail-signature-card-title-container">
            <Heading as={HeadingType.h6}>{title}</Heading>
            <div>{description}</div>
          </div>
        }
        signProfile={approver?.userProfile?.signatureUserProfile}
        signUser={approver?.userProfile?.displayName}
        signDate={approvedDate}
        onRenderContent={(signatureComponent) => {
          return (
            <Grid container alignItems="top" wrap="wrap" gap={1}>
              <Grid item xs={12}>
                <div className="gcl-gems-twc-ge-request-detail-signature-card-remark-container">
                  <Label
                    labelFor={commentFormKey}
                    className="gcl-gems-twc-ge-request-detail-signature-card-remark-label"
                  >
                    Remarks
                  </Label>
                  <FormTextarea
                    formFieldMethods={formFieldMethods}
                    id={commentFormKey}
                    className="gcl-gems-twc-ge-request-detail-signature-card-remark"
                    disabled={readonly}
                  />
                </div>
              </Grid>
              {signatureComponent ? (
                <Grid item xs={12}>
                  <div className="gcl-gems-twc-ge-request-detail-signature-card-approved-container">
                    {signatureLabel ? (
                      <Label
                        labelFor="endorsement-signature"
                        className="gcl-gems-twc-ge-request-detail-signature-card-signature-label"
                      >
                        {signatureLabel}
                      </Label>
                    ) : undefined}
                    {signatureComponent}
                  </div>
                </Grid>
              ) : undefined}
            </Grid>
          );
        }}
      />
    </div>
  );
};
